import { DeleteBlockedSpotResponseType } from "../types/game.types";
import ApiService from "./ApiService";

class GameApi extends ApiService {
  constructor() {
    super(
      `${process.env.BACKEND_HOST_URL}/api` || "https://api.turftown.in/api"
    );
  }

  async getAllGames(
    body?: { city?: string; area?: string },
    useCache?: boolean
  ) {
    return this.post("v2/feed/get_all_games", body, false, useCache);
  }
  async deleteBlockedSpot(body: { game: string; _id: string }) {
    try {
      const response = await this.post<DeleteBlockedSpotResponseType>(
        "v2/game/cancel_block_spot_for_the_game",
        body,
        true
      );
      return response?.data;
    } catch (e) {
      console.log("Error in deleteBlockedSpot", e);
    }
  }
}

export const gameApi = new GameApi();
